import { UnitPreference } from "../../../../../jest/test-utils/helpers";
import { drawingStore } from "../store";

export const setUnitPreference = (unitPreference: UnitPreference) => {
  const actions = drawingStore.reduxStore?.actions;
  const store = drawingStore.reduxStore?.store;
  if (!store || !actions) return;

  store.dispatch(actions.setUnitPreference(unitPreference));
};
